import { pickBy } from 'ramda';

export const pickByTrue = pickBy((val: boolean) => val);
